import {
    AccumulatorName,
    AccumulatorNumbers,
    AccumulatorWithDate,
    MemberAccumulator,
} from "../../../models/Accumulator";

export const getFullName = (ma: MemberAccumulator) => `${ma.firstName} ${ma.middleName} ${ma.lastName}`;

export const isDollarAmount = (accumulationType?: string) => accumulationType === "Dollar Amount";

export const getRemainder = (allotment: number, utilized = 0) => {
    const remainder = +allotment - +utilized;

    return remainder < 0 ? 0 : remainder;
};

export const getPercentUtilized = (allotment: number, utilized = 0) => {
    if (allotment === 0) return 0;
    const percentUtilized = Math.ceil((utilized / allotment) * 100);
    return percentUtilized > 100 ? 100 : percentUtilized;
};

export const getIndividualLimitRemaining = (planYearAllowance: number, accumulators: AccumulatorWithDate[]) => {
    const utilized = accumulators.find((a) => a.accumulatorNumber === AccumulatorNumbers.PlanYearAllowance)
        ?.accumulatorAmt;

    return getRemainder(planYearAllowance, utilized);
};

export const getAccumulatorName = (accumulator: AccumulatorNumbers) => AccumulatorName[accumulator];
